import React from 'react';
import { Icon } from '../icon/Icon';
import './Badge.scss';

interface BadgeProps {
  icon: string;
  secondary?: boolean;
  value: number;
}

export const Badge: React.FC<BadgeProps> = ({ icon, secondary, value }) => {
  return (
    <div className="ads-badge-container">
      {value && icon && (
        <div className="ads-badge" data-testid="ads-badge">
          <div
            className={`ads-badge__value ${
              secondary ? 'ads-badge__value--secondary' : ''
            }`}
            data-testid="ads-badge-indicator"
          >
            {value}
          </div>
          <Icon name={icon} />
        </div>
      )}
    </div>
  );
};
